var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[(_vm.loading)?_c('div',{staticClass:"loadingDimmed"}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"sp-3balls"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }